(() => {
  if (window.mdBookingPopupBound) return;
  window.mdBookingPopupBound = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('a[href], .md-servicify-popup-trigger');
    if (!trigger) return;
    if (trigger.getAttribute('href')?.trim() !== '#booking' && !trigger.classList.contains('md-servicify-popup-trigger')) return;
    const url = document.getElementById('MDBookingPopupConfig')?.dataset.url;
    if (!url) return;
    event.preventDefault();
    if (window.Calendly?.initPopupWidget) {
      window.Calendly.initPopupWidget({ url });
    } else {
      window.location.assign(url);
    }
  });
})();
